import React, { useEffect, useRef, useState } from 'react'
import DropdownArrow from 'images/inline/dropdown-arrow.svg'

/*
This component isn't a form <select>, but it sure seems like one.

This is a refactored version of what's on the referral step.
Our root css className is dropdown2-container to prevent a collision w/ dropdown-container

items is an array [{id,label},{id,label}...]
defaultLabel is displayed if no item is selected
defaultItemId allows parent components to speficy which item is selected
onSelect

*/

const Dropdown = ({ items, defaultLabel, defaultItemId, onSelect }) => {
  const rootRef = useRef()
  const [displayLabel, setDisplayLabel] = useState(defaultLabel)

  useEffect(() => {
    let selectedItem = items.find(item => {
      return item.id === defaultItemId
    })
    if (selectedItem) {
      setDisplayLabel(selectedItem.label)
    } else {
      setDisplayLabel(defaultLabel)
    }
  }, [defaultItemId, defaultLabel])

  const toggleDropdown = (e, link) => {
    rootRef.current.classList.toggle('open')
  }

  const itemClick = (item, e) => {
    setDisplayLabel(item.label)
    onSelect && onSelect(item.id, item.label)
  }

  return (
    <div className={`dropdown2-container`} ref={rootRef}>
      <div
        className="dropdown2-cover"
        role="menu"
        onClick={toggleDropdown}
        onKeyDown={e => {
          if (e.keycode === 13) {
            toggleDropdown && toggleDropdown()
          }
        }}
      >
        <span
          className="dropdown2-text"
          dangerouslySetInnerHTML={{ __html: displayLabel }}
        ></span>
        <DropdownArrow className="arrow" />
        <ul className="dropdown2-list">
          {items &&
            items.length &&
            items.map((item, i) => {
              return (
                <li
                  className="dropdown2-list-item"
                  role="option"
                  key={i}
                  onClick={itemClick.bind(undefined, item)}
                >
                  {item.label}
                </li>
              )
            })}
        </ul>
      </div>
    </div>
  )
}

export default Dropdown
